import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ModalService } from '@core/services/modal/modal.service';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
  selector: 'app-virtual-sidebar',
  templateUrl: './virtual-sidebar.component.html',
  styleUrls: ['./virtual-sidebar.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class SidebarVirtualComponent implements OnInit {

  faCircle = faCircle;

  textcontent: any;
  data = {
    title: '',
    header: '',
    topMessage: '',
    bottomMessage: '',
    icon: '',
    color: '',
    class: 'sidebar-modal',
  };

  constructor(
    private modalService: ModalService,
    private toolService: ToolService
  ) { }

  ngOnInit() {
    this.toolService.content.subscribe((textcontent: any) => this.textcontent = textcontent.shared.virtualSidebar);
  }

  openInformationModal = () => {
    this.data.topMessage = this.textcontent.componentContent.modalContentTop;
    this.data.bottomMessage = this.textcontent.componentContent.modalContentBottom;
    this.modalService.basicInfoAlert(this.data).then((response: any) => {
      // console.log(response);

    });

  }
}
